import { render } from "./UserRoleForm.vue?vue&type=template&id=29d3cf97&ts=true"
import script from "./UserRoleForm.vue?vue&type=script&lang=ts"
export * from "./UserRoleForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__